import React from 'react'
import ImageOverlayLink from '@/components/ImageOverlayLink'

function FeaturedLocations({ locations = [] }) {
  return (
    <div className="hide-scroll flex gap-4 overflow-scroll md:gap-6 lg:gap-6">
      {locations.map(({ imageProps, linkProps, text }) => (
        <div
          className="w-32 flex-none md:w-48 xl:flex-1"
          key={text}
        >
          <ImageOverlayLink
            imageProps={imageProps}
            linkProps={linkProps}
          >
            {text}
          </ImageOverlayLink>
        </div>
      ))}
    </div>
  )
}

export default FeaturedLocations
